module.exports = __webpack_public_path__ + "static/scrum-3a6d32c49a670a65e59583145bbf9f0c.svg";